
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`Son taux d’efficacité a bluffé les experts.`}</p>
    <p>{`Les vaccins à ARNm peuvent être modifiés plus rapidement que leurs homologues
utilisant des techniques traditionnelles. En décembre 2020, BioNTech a assuré
qu’une nouvelle version pouvait être créée en six semaines, s’il fallait
l’adapter à un variant.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;